import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import { Link as MuiLink } from '@mui/material';
import type * as v from 'valibot';
import type { StructuredContentDocument } from '../../hydration/types';
import type { creditCardsPartnerRedirectSchema } from './schema';
export function CreditCardsPartnerRedirect(t0) {
  const $ = _c(10);
  const {
    props: t1
  } = t0;
  const {
    id,
    redirectLink,
    linkType,
    text
  } = t1;
  const isMonetizing = redirectLink.monetizable === true;
  const isActive = redirectLink.status?.toLowerCase() === "active";
  if (!isMonetizing || !isActive) {
    console.error(`CreditCardsPartnerRedirect - marketplace entity is not monetizable or active: ${id}`);
    let t2;
    if ($[0] !== text) {
      t2 = text ? <>{text}</> : null;
      $[0] = text;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  const hasLink = linkType === "rates-and-fees" ? !!redirectLink.termsAndFeesUrl : !!redirectLink.destinationUrl;
  if (!hasLink) {
    console.error(`CreditCardsPartnerRedirect - no link ${linkType} found for: ${id}`);
    let t2;
    if ($[2] !== text) {
      t2 = text ? <>{text}</> : null;
      $[2] = text;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== id || $[5] !== linkType) {
    const url = new URL(`${env.NEXT_PUBLIC_NW_URL}redirect/${id}`);
    url.searchParams.set("finish_type", "external_application");
    url.searchParams.set("cta_type", linkType === "rates-and-fees" ? "RATES_AND_FEES_TEXT" : "APPLY_NOW");
    if (linkType === "rates-and-fees") {
      url.searchParams.set("destination_url_field", "terms_and_fees_link");
    }
    t2 = url.toString();
    $[4] = id;
    $[5] = linkType;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const href = t2;
  const t3 = text || href;
  let t4;
  if ($[7] !== href || $[8] !== t3) {
    t4 = <MuiLink underline="hover" href={href} rel="noopener nofollow" target="_blank">{t3}</MuiLink>;
    $[7] = href;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export type CreditCardsPartnerRedirectProps = StructuredContentDocument<v.InferInput<typeof creditCardsPartnerRedirectSchema>>;